import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { Administrator } from 'src/app/models/administrator.model';
import { Department } from 'src/app/models/department.model';
import { DashboardService } from '../dashboard.service';
import { AdminAuthService } from '../services/admin-auth-service/admin-auth.service';
import { AdminLanguageService } from '../services/admin-language-service/admin-language.service';
import {GeneratedFile} from '../../models/generatedFile.model';
import {MatTableDataSource} from '@angular/material/table';
import {Trainer} from '../../models/trainer.model';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {DeleteDialogComponent} from './delete-dialog/delete-dialog.component';
import {formatDate} from '@angular/common';

@Component({
    selector: 'app-generate-reports',
    templateUrl: './generate-reports.component.html',
    styleUrls: ['./generate-reports.component.scss'],
    standalone: false
})
export class GenerateReportsComponent implements OnInit {
  labels;
  labelsSub: Subscription;
  lang;
  langSub: Subscription;
  users
  departments
  trainings
  list
  generatedFiles: GeneratedFile[] = []
  menuVisibility: boolean = false
  checked: boolean = false;
  generator: boolean = false;
  generatorList: number = 0;
  reportType: boolean = true;
  dates: boolean = false;
  generatorCheckbox: boolean = false;
  @ViewChild('insertForm') insertForm: NgForm
  @ViewChild('insertFormUsers') insertFormUsers: NgForm
  @ViewChild('insertFormSectors') insertFormSectors: NgForm
  usersForReport = new UntypedFormControl();
  admin: Administrator
  adminSub: Subscription

  downloadingSub:Subscription
  downloading :boolean = false

  displayedColumns: string[] = [ 'type', 'filename', 'date', 'status', 'actions'];
  dataSource;
  @ViewChild(MatPaginator,{static:true}) paginator: MatPaginator;
  @ViewChild(MatSort) sort:MatSort

  selectedTraining: any = null; // <-- new property to hold selected training

  constructor(public snackBar: MatSnackBar, private dashboardService: DashboardService, private adminLanguageService: AdminLanguageService, private adminAuthService: AdminAuthService, private dialog: MatDialog,) { }


  ngOnInit(): void {
    this.langSub = this.adminLanguageService.lang$.subscribe((lang) => {
      this.lang = lang;
    })
    this.reportType = true;
    this.generator = false;
    this.generatorList = 0;
    this.dates = false;
    this.generatorCheckbox = false;
    this.getLang()
    this.getAdmin()
    //this.getTrainings()
    this.getTrainingsAndEvents()
    this.list = [{ name: "Sektori", selected: false }, { name: "Korisnici", selected: false }]
    this.getGeneratedReports()
    this.dataSource = new MatTableDataSource(this.generatedFiles)
    this.dataSource.sort = this.sort
    this.dataSource.paginator = this.paginator
    this.dataSource.filterPredicate = (data : Trainer, filter: string) => data.firstName.toLocaleLowerCase().includes(filter.trim().toLocaleLowerCase());
  }

  getLang() {
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
  }

  getUsers() {
    this.dashboardService.getUsersNoPending().subscribe((result) => {
      this.users = result
      console.log(this.users)
    })
  }
  getUsers1() {
    this.dashboardService.getUsersInDep(this.admin.departmentId).subscribe((result) => {
      this.users = result
    })
  }

  getTrainings() {
    this.dashboardService.getTrainings().subscribe((result) => {
      this.trainings = result
    })
  }

  getTrainingsAndEvents(){
    this.dashboardService.getTrainingsAndEvents().subscribe((result) => {
      this.trainings = result
      console.log("TRAININGS AND EVENTS: ", this.trainings)
    })
  }

  fetchDepartments() {
    this.dashboardService.fetchAllDepartments().subscribe((result) => {
      this.departments = result
    })
  }
  fetchDepartments1() {
    this.dashboardService.fetchAdminsDepartments(this.admin.departmentId).subscribe((response) => {
      this.departments = response
    })
  }

  getGeneratedReports() {
    this.dashboardService.getGeneratedReports().toPromise().then((result: GeneratedFile[]) => {
      this.generatedFiles = result
      this.dataSource = new MatTableDataSource(this.generatedFiles)
    })
  }

  generateReport() {
    let type = this.insertForm.value.type
    let username = this.insertForm.value.username || null
    let sectorId = this.insertForm.value.sectorId || null

    if (type == '4') {
      this.dashboardService.generateCommentsReport().toPromise().then((response) => {
        this.dataSource = null
        this.getGeneratedReports()
      }).catch((err) => {
        console.log('Comments report generated successfully', err);
      })
    } else if (type == '3'){
      if(this.insertForm.value.dateFrom && this.insertForm.value.dateTo) {
        this.dashboardService.generateDatedExcelReport("trId", type, this.lang, this.admin.headAdmin, this.admin.departmentId, this.insertForm.value.dateFrom, this.insertForm.value.dateTo, username, sectorId).toPromise().then((response) => {
          this.dataSource = null
          this.getGeneratedReports()
        })
      } else {
        this.dashboardService.generateExcelReport("trId", type, this.lang, this.admin.headAdmin, this.admin.departmentId, username, sectorId).toPromise().then((response) => {
          this.dataSource = null
          this.getGeneratedReports()
        })
      }

    } else if (type == 2) {
      if(this.insertForm.value.dateFrom && this.insertForm.value.dateTo) {
        this.dashboardService.generateDatedTrainingExcelReport(this.insertForm.value.trainingId._id, type, this.lang, this.admin.headAdmin, this.admin.departmentId, this.insertForm.value.dateFrom, this.insertForm.value.dateTo, username, sectorId).toPromise().then((response) => {
          this.dataSource = null
          this.getGeneratedReports()
        })
      } else {
        this.dashboardService.generateTrainingExcelReport(this.insertForm.value.trainingId._id, type, this.lang, this.admin.headAdmin, this.admin.departmentId, username, sectorId).toPromise().then((response) => {
          this.dataSource = null
          this.getGeneratedReports()
        })
      }
    } else {
      let trainingId = this.insertForm.value.trainingId._id
      let isZoomTraining = this.insertForm.value.trainingId.zoomTraining ?? 0
      this.dashboardService.generatReportAdmin(trainingId, type, this.lang, this.admin.headAdmin, this.admin.departmentId, isZoomTraining)
    }

  }

  ngOnDestroy(): void {
    if (this.labelsSub) {
      this.labelsSub.unsubscribe();
    }
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
    if (this.adminSub) {
      this.adminSub.unsubscribe();
    }
    if (this.downloadingSub) {
      this.downloadingSub.unsubscribe();
    }
  }

  openDeleteDialog(file: GeneratedFile) {
    let dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '500px',
      data: file
    })

    dialogRef.afterClosed().subscribe((result) => {
      this.dataSource = null
      this.getGeneratedReports()
    });
  }

  displayStatus(status: any) {
    if (status == 'pending') {
      return this.labels.lblPending
    } else if (status == 'completed') {
      return this.labels.lblCompleted
    } else if (status == 'failed') {
      return this.labels.lblError
    } else {
      return this.labels.lblError
    }
  }

  downloadReport(file: GeneratedFile) {
    this.downloadingSub = this.dashboardService.downloading$.subscribe((downloading) => {
      this.downloading = downloading;
    })
    this.downloading = true
    console.log(this.downloading)
    this.dashboardService.downloadReport(file._id)
  }

  generateReportForSectors() {
    console.log('generate report for sectors')
    let type = this.insertFormSectors.value.type
    let trainingId = this.insertFormSectors.value.trainingId._id
    let isZoomTraining = this.insertFormSectors.value.trainingId.zoomTraining ?? 0
    let fromDate = this.insertFormSectors.value.fromDate
    let toDate = this.insertFormSectors.value.toDate
    let sectorId = this.insertFormSectors.value.depId
    if (fromDate == "") {
      fromDate = null
    }
    if (toDate == "") {
      toDate = null
    }
    let response = this.dashboardService.generateReportForSectors(trainingId, type, fromDate, toDate, sectorId, this.lang, isZoomTraining)
    console.log(response)
  }

  generateReportForUsers() {
    let type = this.insertFormUsers.value.type
    let trainingId = this.insertFormUsers.value.trainingId._id
    let isZoomTraining = this.insertFormUsers.value.trainingId.zoomTraining ?? 0
    let fromDate = this.insertFormUsers.value.fromDate
    let toDate = this.insertFormUsers.value.toDate
    if (fromDate == "") {
      fromDate = null
    }
    if (toDate == "") {
      toDate = null
    }

    console.log("TR ID: ", trainingId)
    console.log("IS TRAINING ZOOM: ", isZoomTraining)
    this.dashboardService.generateReportForUsers(trainingId, type, fromDate, toDate, this.usersForReport.value, this.lang, isZoomTraining)
  }

  getAdmin() {
    this.adminSub = this.adminAuthService.admin$.subscribe((admin) => {
      this.admin = admin;
      console.log(this.admin)
      setTimeout(() => {
        if (admin.headAdmin) {
          this.fetchDepartments();
          this.getUsers()
        }
        else {
          this.fetchDepartments1();
          this.getUsers1()
        }
      }, 100);
    });
  }

  changeMenuVisibility(value) {
    this.selectedTraining = null;
    if (value == '1') {
      this.menuVisibility = true
    }
    else if (value == '2') {
      this.menuVisibility = true
    }
    else {
      this.menuVisibility = false
    }

  }

  protected readonly formatDate = formatDate;
}
